import { render, staticRenderFns } from "./charteredWork.vue?vue&type=template&id=0a51a646&scoped=true"
import script from "./charteredWork.vue?vue&type=script&lang=js"
export * from "./charteredWork.vue?vue&type=script&lang=js"
import style0 from "./charteredWork.vue?vue&type=style&index=0&id=0a51a646&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a51a646",
  null
  
)

export default component.exports